import IDMGlobals from '../../IDMGlobals';
//
export default class APIExternalProvider {
  constructor(API) {
    this.api = API
  }
  async get() {
    const req = await this.api.newBaseRequest('GET')
    req.path = IDMGlobals.APIPath_ExternalProviders
    return await req.exec()
  }
  async getAzureAuthorizationURL(redirectURL, state) {
    const req = await this.api.newBaseRequest('POST')
    req.body = { redirectURL, state }
    req.path = IDMGlobals.APIPath_ExternalProviders + '/azure/auth'
    return await req.exec()
  }
  async getGoogleAuthorizationURL(redirectURL, state) {
    const req = await this.api.newBaseRequest('POST')
    req.body = { redirectURL, state }
    req.path = IDMGlobals.APIPath_ExternalProviders + '/google/auth'
    return await req.exec()
  }
  async getFacebookAuthorizationURL(redirectURL, state) {
    const req = await this.api.newBaseRequest('POST')
    req.body = { redirectURL, state }
    req.path = IDMGlobals.APIPath_ExternalProviders + '/facebook/auth'
    return await req.exec()
  }
  async getAppleAuthorizationURL(redirectURL, state) {
    const req = await this.api.newBaseRequest('POST')
    req.body = { redirectURL, state }
    req.path = IDMGlobals.APIPath_ExternalProviders + '/apple/auth'
    return await req.exec()
  }
  async getExternalProviderLogoutURL(redirectURL, state) {
    const req = await this.api.newBaseRequest('POST')
    req.body = { redirectURL, state }
    req.path = IDMGlobals.APIPath_ExternalProviders + '/logout'
    return await req.exec()
  }
}
